export enum EtapeCreationOrdoWebAyEnum {
	A_FAIRE = "todo",
	EN_COURS = "on",
	FINI = "done",
}
